<template>
  <div class="des-details-wrapper">
    <div>
      <bio-navbar></bio-navbar>
    </div>
    <div class="des-main-container">
      <router-view :key="key"></router-view>
    </div>
    <bio-footer></bio-footer>
  </div>
</template>

<script>
import { BioNavbar, BioFooter } from './components'

export default {
  name: 'LayoutTopBtm',
  components: {
    BioNavbar,
    BioFooter,
  },
  computed: {
    key() {
      return this.$route.fullPath
    }
  }
  //mixins: [ResizeMixin],
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .des-details-wrapper{
    position: relative;
    min-height: 100vh;
    height: 100%;
    width: 100%;
    background-color: #efefef;
  }
.des-main-container{
    min-height: 100%;
    width: 1200px;
    margin: 0 auto;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutTopBtm.vue